module.exports = __webpack_public_path__ + "img/4.87d679dc.png";